import React, { FunctionComponent, useEffect, useState } from 'react';
import Card from '@Components/Card/Card';
import useScreen from '@Utils/hooks/useScreen';
import { getResponsiveModalStyles, getResponsiveModalStyles2 } from '@Utils/layout/layoutSupport';
import { ModalContainer } from '@Components/Modal/subComponents/ModalContainer/ModalContiner.styled';
import { AnimatedModalContainer } from '@Components/Modal/subComponents/AnimatedModalContainer/AnimatedModalContiner.styled';
import { setModal } from '@Redux/modules/modal/actions';
import { useDispatch } from 'react-redux';
import { Subscription, timer } from 'rxjs';

const ModalAddedToCart: FunctionComponent<types.cards.IAddedToCartCardProps['params']> = ({
	orderId,
	isSimplifiedCheckout,
}) => {
	const { screenClass } = useScreen();
	const dispatch = useDispatch();
	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		const subscription: Subscription = timer(0).subscribe(() => {
			setIsOpen(true);
		});
		return () => subscription.unsubscribe();
	}, []);

	const onCartClear = () => {
		setIsOpen(false);
		timer(2000).subscribe(() => {
			closeModal();
		});
	};

	const closeModal = () => {
		dispatch(
			setModal({
				type: null,
				data: null,
			})
		);
	};

	if (isSimplifiedCheckout) {
		return (
			<AnimatedModalContainer isOpen={isOpen} styles={getResponsiveModalStyles2(screenClass)}>
				<Card<types.cards.IAddedToCartCardProps>
					params={{ orderId, isSimplifiedCheckout, onCartClear }}
					card="addedToCart"
					withoutContainer
				/>
			</AnimatedModalContainer>
		);
	}

	return (
		<ModalContainer styles={getResponsiveModalStyles(screenClass)}>
			<Card<types.cards.IAddedToCartCardProps> params={{ orderId }} card="addedToCart" withoutContainer />
		</ModalContainer>
	);
};

export default ModalAddedToCart;
